import { AbstractCountedResultList, CountedResultList } from '@uzurv/core';
import { autoserializeAs, inheritSerialization } from 'cerialize';
import { RideMonitoringAlert } from '../ride-monitoring-alert';

@inheritSerialization(AbstractCountedResultList)
export class RideMonitoringAlertList extends AbstractCountedResultList implements CountedResultList<RideMonitoringAlert> {
  @autoserializeAs(RideMonitoringAlert)
  results: Array<RideMonitoringAlert>;
}
